
import Vue from "vue";
import Component from "vue-class-component";
import LoaderContainer from "@/components/Loader.vue";
import PedidoService from "@/services/PedidoService";
import DetalhePedidoContainer from "@/components/pedido/DetalhePedidoContainer.vue";

@Component({
  name: "DetalhesPedidoView",
  components: {
    LoaderContainer,
    DetalhePedidoContainer,
  },
})
export default class DetalhesPedidoView extends Vue {
   isLoading = true;
   pedido = {} as any;

  mounted() {
    this.buscarDadosPedido();
  }

  buscarDadosPedido() {
    const { nroPedido } = this.$router.currentRoute.params;
    PedidoService.findOneByNroPedido(nroPedido)
      .then((resp) => {
        this.pedido = resp.data;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  onVoltarClick() {
    this.$router.back();
  }
}
